<template>
    <div>
        <modal
            class="new-modal-verysmall"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important;" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 17em !important;">
                <div class="mt-1 fw-600" style="font-size: 16px">
                    A Deal Must Have Atleast One Product
                </div>
                <div class="mt-3" style="margin-left: -35px;">
                    
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-no-button mr-4 px-4" @click="hideSelf">OK</button>
                    <!-- <button class="btn new-yes-button ml-4 px-4" @click="confirmUpdate">Yes</button> -->
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-no-button mr-4 px-4" disabled>OK</button>
                    <!-- <button class="btn new-yes-button ml-4 px-4" disabled style="position: relative;">Yes -->
                        <!-- <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                    <!-- </button> -->
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    data(){
        return{
            disableButtonAndDisplayLoader: false,
        }
    },
    components: {
        HollowDotsSpinner
    },
    props: ["modal_name"],
    methods: {
        hideSelf() {
            this.$emit("hidePopup");
            this.$modal.hide(this.modal_name);
        },
        // confirmUpdate() {
        //     this.disableButtonAndDisplayLoader = true;
        //     this.$emit("updateStatus");
        //     setTimeout(() => {
        //         this.disableButtonAndDisplayLoader = false;
        //         this.$modal.hide(this.modal_name);
        //     }, 1500);
        // }
    },
    computed: {
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Deals/OneDealDeletePopup.vue